// extracted by mini-css-extract-plugin
export default {"tooltip":"LR-z","arrow":"MR-z"};